// Не знаю как лучше отправлять аналитику на клик
// или показ по блоку по условию для ФСК
import { FSK_SP_NAME } from '../constants/specialProjects/fskSpecialProject';

export function isFskByIconName(icon?: string) {
  return Boolean(icon && icon === FSK_SP_NAME);
}
